/* eslint-disable @nx/enforce-module-boundaries */
import { Modal, ModalContent, ModalOverlay } from '@mybridge/ui/modal';
import { useState } from 'react';
import { DashboardPostContainer } from '../post-container';
import { useRouter } from 'next/router';
import { Text } from '@mybridge/ui';

// export const DashboardPostModal = ({ postId, ...props }) => {
export const DashboardPostModal = ({ postId, initialPostData, openMedia, onClose, ...props }) => {
  const [expanded, setExpanded] = useState(false);
  const { back, push } = useRouter();
  return (
    <Modal
      size={expanded ? 'full' : '2xl'}
      {...props}
      motionPreset="slideInBottom"
      closeOnOverlayClick={true}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={expanded ? 0 : 16}
        // overflow="hidden"
        border="none"
        marginTop={!expanded ? `40px` : '0'}
        /* minW={{ base: "auto", sm: "750px" }} */
        minW={{ base: "auto", md: "750px" }}
        // maxH={"100vh"}
      >
        <DashboardPostContainer
          onClose={(e) => {
            // back?.();
            // push('/')
            if (onClose) {
              onClose(e);
            } else {
              push('/');
            }
          }}
          postId={postId}
          initialPostData={initialPostData}
          openMedia={openMedia}
          setHasMedia={(m) => {
            setExpanded(m);
          }}
        />
      </ModalContent>
    </Modal>
  );
};
